import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect, shallowEqual, useSelector } from 'react-redux';
import * as videoStoriesOverlayStyles from './VideoStoriesOverlay.scss';
import * as Styles from './View.scss';
import VideoStoriesSwiper from './VideoStoriesSwiper';
function VideoStoriesOverlay(props) {
    useStyles(videoStoriesOverlayStyles, Styles);
    const videoStoryTemplateQueue = useSelector((state) => state.VideoStoriesMedia.metadata.videoStoryTemplateQueue, shallowEqual);
    return (React.createElement(VideoStoriesSwiper, { className: videoStoriesOverlayStyles.videoStoriesOverlay, template: props.template, templateQueue: videoStoryTemplateQueue }));
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withStyles(Styles)(connect(null, mapDispatchToProps)(VideoStoriesOverlay));
